import { NumberInput, Stack, Text } from '@mantine/core';

import { toNumberOrDefault } from '../numberInputValue';
import { FieldLabelWithHelp } from './FieldLabelWithHelp';

interface FormulaFieldProps {
  description?: string;
  disabled?: boolean;
  error?: string;
  /** Value a cleared input snaps back to — every field has its own sensible one (e.g. 1 for a
   * per-increment divisor, 0 for most amounts), so it's always supplied by the caller.
   */
  fallback: number;
  label: string;
  min?: number;
  onChange: (value: number) => void;
  tooltip?: string;
  value: number;
}

/**
 * Puts the hint below the input (matching the mockup) instead of Mantine's default
 * label-description-input order, so sibling fields' inputs stay aligned regardless of hint length.
 * Uses NumberInput (not TextInput) so every quality-formula amount/bound field enforces the same
 * numeric keyboard/format the API requires, matching RangeRowsTable's Range-mode fields.
 */
export const FormulaField: React.FC<FormulaFieldProps> = ({
  description,
  disabled,
  error,
  fallback,
  label,
  min,
  onChange,
  tooltip,
  value,
}) => (
  <Stack gap={4}>
    <NumberInput
      disabled={disabled}
      error={error}
      hideControls
      label={tooltip ? <FieldLabelWithHelp label={label} tooltip={tooltip} /> : label}
      min={min}
      onChange={value => {
        onChange(toNumberOrDefault(value, fallback));
      }}
      value={value}
    />
    {description ? (
      <Text c="dimmed" fz="xs">
        {description}
      </Text>
    ) : null}
  </Stack>
);
